module.exports = __webpack_public_path__ + "img/patent_image2.833976df.png";